import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { FloatingCard } from '../../themes/DefaultTheme';
import LocalIQSpinner from '../LoadingSpinner/LoadingSpinner';
import { ProgressBlockWrapper } from './styled';

/**
 * Card for use in loading/saving applications.
 */
export default function LoadingCardAuth0({
  progressText,
}) {
return (
    <FloatingCard>
      <ProgressBlockWrapper>
        <Typography variant="h5" component="div">
          {progressText}
        </Typography>
        <LocalIQSpinner height={100} width={100} />
      </ProgressBlockWrapper>
    </FloatingCard>
  );
}

LoadingCardAuth0.propTypes = {
  /**
   * The text to show above the progress bar
   */
  progressText: PropTypes.string,
};
